// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Spinner,
  Col,
  FormFeedback,
} from "reactstrap";
import Header from "components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { addPatient } from "store/services/patient.service";
import { useHistory } from "react-router-dom";
import { getPatients } from "store/services/patient.service";
import { GET_PATIENTS } from "store/types";
import { isMobile } from "utils/strings";

const RequestForm = (props) => {
  const dispatch = useDispatch();
  const { exams } = useSelector((state) => state.exams);
  const { username } = JSON.parse(window.sessionStorage.getItem("user"));

  const today = new Date();

  const date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const [showSpinner, setShowSpinner] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [patientPhone, setPatientPhone] = useState("");
  const [patientAge, setPatientAge] = useState("");
  const [patientGender, setPatientGender] = useState("male");
  const [patientExam, setPatientExam] = useState("CBCT Segment");
  const [patientNotes, setPatientNotes] = useState("");

  // Input Validation
  const [isPhone, setIsPhone] = useState(false);
  const [isName, setIsName] = useState(false);
  const [isAge, setIsAge] = useState(false);
  const [isGender, setIsGender] = useState(false);

  const history = useHistory();

  const handelAddPatient = () => {
    setShowSpinner(true);
    const checkMobile = isMobile(patientPhone);
    setIsPhone(checkMobile);
    if (!patientName) {
      setIsName("Name can not be empty");
    }
    if (!patientAge) {
      setIsAge("Age is not correct");
    }
    if (!patientGender) {
      setIsGender("Chose gender please ");
    }
    if (isMobile(patientPhone) && !isName && !isAge && !isGender) {
      const data = {
        patient_name: patientName,
        doctor_name: username,
        date: new Date().toISOString(),
        exam: patientExam,
        mobile: patientPhone,
        age: patientAge,
        status: "pending",
        notes: patientNotes,
        gender: patientGender,
      };
      addPatient(data, true).then(() => {
        getPatients().then((data) => {
          dispatch({ type: GET_PATIENTS, payload: data });
        });
        history.push("/admin/tables");
      });
    }
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">New Request</h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    {showSpinner ? (
                      <Spinner color="primary" />
                    ) : (
                      <Button
                        color="primary"
                        onClick={handelAddPatient}
                        size="sm"
                      >
                        ADD PATIENT
                      </Button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    Patient information
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Name
                          </label>
                          <Input
                            className="form-control-alternative"
                            onChange={(e) => {
                              setPatientName(e.target.value);
                              setIsName(false);
                              setShowSpinner(false);
                            }}
                            id="input-username"
                            placeholder="name"
                            type="text"
                            invalid={isName}
                          />
                          <FormFeedback>{isName}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Phone Number
                          </label>
                          <Input
                            className="form-control-alternative"
                            onChange={(e) => {
                              setPatientPhone(e.target.value);
                              setIsPhone(false);
                              setShowSpinner(false);
                            }}
                            id="input-email"
                            placeholder="07********"
                            type="phone"
                            invalid={isPhone}
                          />
                          <FormFeedback>{isPhone}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Age
                          </label>
                          <Input
                            onChange={(e) => {
                              setPatientAge(e.target.value);
                              setIsAge(false);
                              setShowSpinner(false);
                            }}
                            className="form-control-alternative"
                            id="input-first-name"
                            placeholder="Age"
                            type="text"
                            invalid={isAge}
                          />
                          <FormFeedback>{isAge}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Date
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={date}
                            id="input-first-name"
                            placeholder="First name"
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-last-name"
                          >
                            Gender
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-last-name"
                            placeholder="Last name"
                            type="select"
                            onChange={(e) => {
                              setPatientGender(e.target.value);
                              setIsGender(false);
                              setShowSpinner(false);
                            }}
                            invalid={isGender}
                          >
                            <option>Male</option>
                            <option>Female</option>
                          </Input>
                          <FormFeedback>{isGender}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                  {/* Address */}
                  <h6 className="heading-small text-muted mb-4">
                    Doctor information
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-last-name"
                          >
                            Exam
                          </label>
                          <Input
                            onChange={(e) => setPatientExam(e.target.value)}
                            className="form-control-alternative"
                            id="input-last-name"
                            placeholder="Last name"
                            type="select"
                          >
                            {exams?.map((item) => (
                              <option>{item}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                  {/* Description */}
                  <h6 className="heading-small text-muted mb-4">Notes</h6>
                  <div className="pl-lg-2">
                    <FormGroup>
                      <Input
                        onChange={(e) => setPatientNotes(e.target.value)}
                        className="form-control-alternative"
                        placeholder="A few words the patient"
                        rows="4"
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RequestForm;
